import React, { Component } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
class AdminPrinterChangeFilament extends Component {
    state = {
        filaments: []
    }
    componentDidMount(){
        axios.get("/api/filament/get-all").then(res=>{
            this.setState({filaments: res.data.filaments})
        })
    }
    selectFilament=(filamentId)=>{
        axios.post("/api/printers/set/filament", {filamentId: filamentId, printerId: this.props.printer.printer._id})
        this.props.close()
    }
    render() {
        let printer = this.props.printer
        let filaments = []
        this.state.filaments.forEach(filament=>{
            filaments.push(
                <div>
                    <p>{filament.name}</p>
                    <p>{filament.type}</p>
                    <Button onClick={()=>this.selectFilament(filament._id)}>Select</Button>
                </div>
            )
            filaments.push(<hr/>)
        })
      
        return (
            <div style={{ height: "100%", width: "80vw" }} >
                {filaments}
            </div>
        );
    }
}

export default AdminPrinterChangeFilament;